import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';

export class VesselsPage extends Component {
  render() {
    return (
      <Page>
        <TitleBar icon="users" title="Vessels" />
        <Card className="content pa3">
          <h3 className="h5 h-auto">What this page will be</h3>
          <p>
            We need to track where our kegs are at any given time in a less manual way. While there's work to be done
            around how we practically tie in workflows to this app, this page will show all our kegs etc and their
            current status. Are they empty? Are they with a customer? If so, what order were they used with? etc.
          </p>
        </Card>
      </Page>
    );
  }
}

export default connect(state => state)(VesselsPage);



// WEBPACK FOOTER //
// ./src/pages/vessels/vessels.jsx